import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHTML',
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    return value.replace(/<[^>]*>/g, '').trim();
  }
}
